module.exports = __webpack_public_path__ + "static/media/masterpass.6175da65.png";